export default __webpack_public_path__ + "6b044c53d2ef0c9f0e7975d404e990ae.png";